import { UserAgentApplication, Configuration, AuthResponse } from "msal";

const isIE = () => false; // /Trident\/|MSIE /.test(window.navigator.userAgent);

export const isRedirected = isIE; // test with () => true;

const LoginScopes = ["openid", "profile", "User.Read"];

const DirectoryAccessScopes = ["Directory.AccessAsUser.All"];

let userAgentApplication: UserAgentApplication;

const createUserAgentApplication = (clientId: string, authority: string | undefined, authCallback: any) => {
    if (userAgentApplication) {
        throw new Error("MSAL instance has already been created.");
    }

    const redirectUri: string = window.location.origin;
    const config: Configuration = {
        auth: {
            clientId,
            authority,
            redirectUri,
            navigateToLoginRequestUrl: false
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: isIE()
        },
        system: {
            navigateFrameWait: 0
        }
    };

    userAgentApplication = new UserAgentApplication(config);
    if (isRedirected()) {
        userAgentApplication.handleRedirectCallback(authCallback);
    }
};

export const getAccessToken = async (scopes = DirectoryAccessScopes, redirect = isIE()) => {
    let response: AuthResponse;
    try {
        response = await userAgentApplication.acquireTokenSilent({ scopes });
        return response.accessToken;
    } catch (error) {
        if (error.errorMessage.indexOf("interaction_required") >= 0) {
            try {
                if (redirect) {
                    await userAgentApplication.acquireTokenRedirect({ scopes });
                } else {
                    response = await userAgentApplication.acquireTokenPopup({ scopes });
                    return response.accessToken;
                }
            } catch (failure) {
                console.error(`Access token not acquired: ${failure.message}`);
            }
        } else {
            console.error(`Access token not acquired: ${error.message}`);
        }
    }
    return null;
};

export const getAccount = () => (userAgentApplication ? userAgentApplication.getAccount() : null);

export const logout = () => (userAgentApplication ? userAgentApplication.logout() : null);

export const loginPopup = (scopes = LoginScopes) =>
    userAgentApplication ? userAgentApplication.loginPopup({ scopes }) : null;

export const loginRedirect = (scopes = LoginScopes) =>
    userAgentApplication ? userAgentApplication.loginRedirect({ scopes }) : null;

export default createUserAgentApplication;
